/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { ActionDetailsServiceRepositoryImpl } from '../impls/ActionDetailsServiceRepositoryImpl';
import { IActionDetailsServiceRepository } from '../interfaces/IActionDetailsServiceRepository';
import { TActionDetailsParams, TActionDetailsList } from '../types';
import { TServicesParams } from '../types/TServicesParams';

export class ActionDetailsService implements IActionDetailsServiceRepository {
    private oActionDetailsServiceRepository: IActionDetailsServiceRepository;

    constructor(params: TServicesParams) {
        this.oActionDetailsServiceRepository = new ActionDetailsServiceRepositoryImpl(params);
    }

    async fetchOfferActionDetails(
        actionDetailsParams: TActionDetailsParams,
    ): Promise<TActionDetailsList> {
        return this.oActionDetailsServiceRepository.fetchOfferActionDetails(actionDetailsParams);
    }
}
